import { useEffect, useRef } from 'react';
import { Outlet, useParams } from 'react-router-dom';
import { useCarrito } from '../../features/carrito/useCarrito';
import { isAuthenticated } from '../../lib/guard';

export function StoreLayout() {
  const { slug } = useParams();
  
  // CAMBIO CLAVE: Usamos refreshCart en lugar de syncWithBackend
  // refreshCart = Descargar verdad del servidor (Mata zombies)
  // syncWithBackend = Subir mentiras locales (Crea zombies al recargar)
  const refreshCart = useCarrito((state) => state.refreshCart);
  
  const isUserLoggedIn = isAuthenticated();

  // SEMÁFORO (Control de Tráfico):
  const syncLock = useRef('');

  useEffect(() => {
    const signature = `${slug}-${isUserLoggedIn}`;

    // LÓGICA DE SEMÁFORO:
    if (isUserLoggedIn && slug && syncLock.current !== signature) {
      
      syncLock.current = signature;
      
      console.log(`🔒 Semáforo activo: Obteniendo carrito real para ${slug}`);
      
      // Ejecutamos la descarga de datos reales
      refreshCart(slug);
    }
  }, [slug, isUserLoggedIn, refreshCart]);

  return <Outlet />;
}